/* src/app/private/components/tickets/ticket-middle-view/ticket-middle-view.component.scss */
.p-avatar {
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 50%;
}
.p-link {
  display: block;
  color: #1976d2;
  text-decoration: underline;
  margin-bottom: 4px;
}
.p-tabpanels {
  padding: 0px !important;
}
.attachment-icon {
  height: 24px;
  width: 24px;
  object-fit: contain;
}
.attachment-item {
  background-color: var(--secondry-light-gray);
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.files-shared-container {
  padding: 0;
  height: 100%;
}
.attachments-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.attachment-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 1rem;
}
.attachment-card:hover {
  border-color: var(--primary-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.attachment-icon-container {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--secondry-light-gray);
  border-radius: 8px;
  position: relative;
}
.attachment-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}
.attachment-icon {
  font-size: 24px;
  color: var(--primary-color);
}
.attachment-icon-fallback {
  font-size: 24px;
  color: var(--primary-color);
}
.attachment-info {
  flex: 1;
  min-width: 0;
}
.attachment-name {
  font-weight: 600;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.attachment-meta {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}
.attachment-size {
  font-size: 12px;
  background: var(--secondry-light-gray);
  padding: 2px 6px;
  border-radius: 4px;
  width: max-content;
}
.attachment-date {
  font-size: 12px;
  color: #6b7280;
}
.attachment-uploader {
  font-size: 11px;
  color: #9ca3af;
}
.attachment-actions {
  display: flex;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.attachment-card:hover .attachment-actions {
  opacity: 1;
}
.empty-state {
  text-align: center;
  padding: 3rem 1rem;
  color: #6b7280;
}
.empty-icon {
  font-size: 4rem;
  color: #d1d5db;
  margin-bottom: 1rem;
}
.empty-state h4 {
  margin-bottom: 0.5rem;
  color: #4b5563;
}
.empty-state p {
  margin-bottom: 1.5rem;
}
.image-viewer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: #f8f9fa;
  border-radius: 8px;
}
.video-container {
  width: 100%;
  text-align: center;
}
.video-container video {
  max-width: 100%;
  max-height: 60vh;
}
.file-preview {
  text-align: center;
  padding: 2rem;
}
.file-upload-content {
  text-align: center;
  padding: 1rem;
}
.file-input-wrapper {
  margin-bottom: 1rem;
}
.selected-files {
  text-align: left;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0.75rem;
  background: #f9fafb;
}
.selected-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px solid #e5e7eb;
}
.selected-file-item:last-child {
  border-bottom: none;
}
.file-name {
  font-weight: 500;
  color: #374151;
}
.file-size {
  color: #6b7280;
  font-size: 0.875rem;
}
@media (max-width: 768px) {
  .attachments-grid {
    grid-template-columns: 1fr;
  }
  .attachment-card {
    flex-direction: column;
    text-align: center;
  }
  .attachment-actions {
    opacity: 1;
    margin-top: 1rem;
  }
}
/*# sourceMappingURL=ticket-middle-view.component.css.map */
